import { proxy } from 'valtio'

const state = proxy({ domains: [], currentDomain: "" })

export { state };